// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "X_HOURS_IN_Y_PERIOD_TYPE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xHoursInYPeriodType: {
        required: findSchemaRequired(typeSchema, "xHoursInYPeriodType"),
        title: "X Hours In Y Period Type",
        properties: {
          hours: {
            type: "integer",
            title: "Hours",
          },
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
          fteProRata: findSchemaPropertyByName(typeSchema, "xHoursInYPeriodType", "fteProRata"),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xHoursInYPeriodType"],
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  xHoursInYPeriodType: {
    fteProRata: {
      "ui:title": t("ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT"),
      "ui:widget": "toggle",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
